<template>
  <div id="body" style="width: 100%;height: 100%;overflow: hidden;">
    <top style="height: 50px;"></top>
    <div style="display: flex;height: calc(100% - 140px);overflow: hidden;">
      <div style="width: 200px;overflow: scroll;">
        <menu-nav></menu-nav>
      </div>
      <router-view style="flex: 1;"></router-view>
    </div>
    <footers style="height: 80px;"></footers>
  </div>
</template>

<script>
  import top from "../top/index.vue";
  import footer from "../footer/index.vue";
  import menuNav from "../menu/index.vue";

  export default {
      components: {
        top,
        'footers':footer,
        menuNav
      },
      name: "index",
      data() {
        return {
        };
      },
      mounted() {
      },
      methods: {
      }
    };
</script>

<style>
  #body{
    background-color: rgba(18, 18, 18, 1);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/page/index/index.vue